module.exports = __webpack_public_path__ + "static/img/hkb.1dd5ffd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/hkb.png
// module id = +seC
// module chunks = 93